import { ErrorBoundary, FallbackProps } from "react-error-boundary"
import { useTranslation } from "react-i18next"
import { Card } from "../Card"
import GetEnvironment from "../../enviroments"
import { Select } from "../Select"
import Oops from "../Oops/Oops"
import { ELIGIBLE_ACCOUNTS } from "../../api/QuadriApi"
import { useQuery } from "@apollo/client"
import { useEffect, useState } from "react"

interface CompanyWithLicenses {
  companyName: string
  companyIdEms: string
  licenses: License[]
}

interface License {
  productId: string
  productName: string
}

interface QuadriOwnershipSettingsProps {
  extensionOwnership: string | undefined
  extensionOwnershipName: string | undefined
  setExtensionOwnership: (value: string | undefined) => void

  disableEdit?: boolean
}

const QuadriOwnershipSettings = (props: QuadriOwnershipSettingsProps) => {
  const { t } = useTranslation("config")
  return (
    <div className="row">
      <div className="col-12">
        <Card header={t("quadriOwnershipSettings.header")}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <QuadriOwnershipSettingsInner {...props} />
          </ErrorBoundary>
        </Card>
      </div>
    </div>
  )
}

const QuadriOwnershipSettingsInner = (props: QuadriOwnershipSettingsProps) => {
  const { t } = useTranslation("config")
  const { extensionOwnership, extensionOwnershipName, setExtensionOwnership } = props
  const { disableEdit } = props

  const { data, loading, error } = useQuery(ELIGIBLE_ACCOUNTS)

  // Catch is done by a ErrorBoundary component up the hierarchy
  if (error) throw error

  const accountsData: CompanyWithLicenses[] = data?.eligibleAccountsWithLicenses
  let accounts = accountsData || []

  if (extensionOwnership && extensionOwnershipName && disableEdit) {
    accounts = [{ companyName: extensionOwnershipName, companyIdEms: extensionOwnership, licenses: [] }]
  }

  console.log("Extension ownership inner: ", extensionOwnership)
  console.log("Accounts: ", accounts)

  return (
    <>
      <div className="col-12 col-lg-4">
        <p className="text-meta display-linebreak">{t("quadriOwnershipSettings.description")}</p>
      </div>
      <div className="col-12 col-lg-8">
        <Select
          label={t("quadriOwnershipSettings.extensionOwnership")}
          extensionBold={t("quadriOwnershipSettings.extensionBold")}
          value={extensionOwnership}
          onChange={(e: any) => {
            setExtensionOwnership(e.target.value)
          }}
          options={accounts.map((oa) => ({
            value: oa.companyIdEms,
            label: oa.companyName
          }))}
          disabled={disableEdit}
          required={true}
          loading={loading}
          showDisabledAsText={true}
        />
      </div>
    </>
  )
}

// TODO: Generalize and share this
// Custom error fallback to make it fit in a card with proper formatting
const ErrorFallback = (props: FallbackProps) => (
  <div className="col-12 col-lg-4 align-center">
    <Oops body={props.error.message} />
  </div>
)

export default QuadriOwnershipSettings
